import React, { createContext, useContext } from 'react';

interface ScrollCloseToBottomContextData {
  isCloseToBottom: boolean;
}

interface Props extends ScrollCloseToBottomContextData {
  children: React.ReactElement;
}

const ScrollCloseToBottomContext = createContext<ScrollCloseToBottomContextData>(
  {} as ScrollCloseToBottomContextData
);

const ScrollCloseToBottomProvider: React.FC<Props> = ({ children, isCloseToBottom }) => {
  return (
    <ScrollCloseToBottomContext.Provider
      value={{
        isCloseToBottom,
      }}>
      {children}
    </ScrollCloseToBottomContext.Provider>
  );
};

const useScrollCloseToBottomContext = (): ScrollCloseToBottomContextData => {
  const context = useContext(ScrollCloseToBottomContext);

  if (!context) {
    throw new Error(
      'useScrollCloseToBottomContext must be used within an ScrollCloseToBottomContext'
    );
  }
  return context;
};

export {
  ScrollCloseToBottomProvider,
  useScrollCloseToBottomContext,
  ScrollCloseToBottomContextData,
};
